import React from "react";
import Swal from "sweetalert2";
import doc5Service from "../../../services/doc5.service";

const BthDeleteDoc5 = (props: { id: number; type: string }) => {
  const { type, id } = props;

  const onDelete = () => {
    Swal.fire({
      title: `ต้องการลบ ${type}5?`,
      text: `คุณต้องการลบ ${type}5 รหัส ${id} ใช่หรือไม่!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ใช่, ลบเลย!",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        //ยิงไปหลังบ้าน delete แล้วลบ ค่อยแสดงข้อความ
        doc5Service.delele(id).then(() => {
          Swal.fire("Deleted!", "Your file has been deleted.", "success").then(
            () => {
              window.location.reload();
            }
          );
        });
      }
    });
  };
  return (
    <>
      <button className="btn btn-sm btn-danger" onClick={onDelete}>
        ลบ
      </button>
    </>
  );
};

export default BthDeleteDoc5;
